import { render } from "./StatBox.vue?vue&type=template&id=63c5d18c&scoped=true"
import script from "./StatBox.vue?vue&type=script&lang=js"
export * from "./StatBox.vue?vue&type=script&lang=js"

import "./StatBox.vue?vue&type=style&index=0&id=63c5d18c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c5d18c"]])

export default __exports__